import { Component, Input } from "@angular/core";

@Component({
  selector: "app-news-status",
  templateUrl: "./news-status.component.html",
  styleUrls: ["./news-status.component.scss"],
})
export class NewsStatusComponent {
  @Input() status: string;

  filledCircleText: string = "&#9679;";
  emptyCircleText: string = "&#9675;";
}
